<p>
  manage-fine-type works!
</p>
